import type { JSX } from 'react';

import type { PrefetchedDataProps } from 'src/shared/prefetch';
import { withPrefetchedData } from 'src/shared/prefetch';

import type { PetitionGammaCommonProps } from 'src/app/pages/petitionGamma/shared/types';

import { ShareHeadlineProvider } from '../../hooks/shareHeadline';
import { getFacebookExperimentHeadline } from '../api';
import { CommonPetitionDetails } from '../CommonPetitionDetails';

type PrefetchedData = Readonly<{
	title: string;
	description: string;
}>;

export const PetitionDetailsFacebookExperiment = withPrefetchedData(
	({ userInfoState, prefetchedData }: PetitionGammaCommonProps & PrefetchedDataProps<PrefetchedData>): JSX.Element => {
		const { title, description } = prefetchedData ?? {};

		if (!title || !description) {
			return <CommonPetitionDetails userInfoState={userInfoState} />;
		}

		return (
			<ShareHeadlineProvider title={title} description={description}>
				<CommonPetitionDetails userInfoState={userInfoState} />
			</ShareHeadlineProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [CommonPetitionDetails],
		prefetchData: async (context) => {
			const {
				params: { experimentName, experimentVariantName },
			} = context;
			if (!(experimentName && experimentVariantName)) {
				return { title: '', description: '' };
			}
			try {
				const result = await getFacebookExperimentHeadline(
					experimentName,
					experimentVariantName,
					context.utilityContext,
				);
				return result ?? { title: '', description: '' };
			} catch (e) {
				return { title: '', description: '' };
			}
		},
	},
);
